/*
 * Public API Surface of ngs-workspace
 */

export * from './lib/ngs-workspace.service';
export * from './lib/ngs-workspace.module';
export * from './lib/models/workspace-data.token';
export * from './lib/models/workspace-ref.model';
export * from './lib/models/workspace-tab-ref.model';
export * from './lib/models/workspace-error.types';
export * from './lib/models/workspace-error.model';
export * from './lib/directives/workspace-header.directive';
export * from './lib/directives/workspace-close.directive';
